import { render, staticRenderFns } from "./AsetAkumulasi.vue?vue&type=template&id=668911a9&"
import script from "./AsetAkumulasi.vue?vue&type=script&lang=js&"
export * from "./AsetAkumulasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports